import React from 'react';
import { Box, Typography, Switch, Divider } from '@mui/material';
import Header from '../widgets/Header';
import { togglePreference } from '../../services/preferenceService';
import { useTranslation } from 'react-i18next';

function Notifications({ user, setUser }) {

    const { t } = useTranslation();

    const [isPushEnabled, setIsPushEnabled] = React.useState(user?.preferences?.pushNotification || false);
    const [isEmailEnabled, setIsEmailEnabled] = React.useState(user?.preferences?.emailNotification || false);
    const devicesConnectedCount = user?.pushTokens?.length || 0;
    return (
        <Box>
            <Header text={t('my_notifications')} />
            <Box 
                sx={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'space-between', 
                    padding: 2
                    }}
                >
                    <Box>
                <Typography>
                    {t('push_notifications')}
                </Typography>
                <Typography variant="subtitle2" sx={{ color: '#888' }}>
                    {t('connected_devices', { devicesConnectedCount })}
                </Typography>
                </Box>
                <Switch
                    checked={isPushEnabled}
                    onChange={async () => {
                       await togglePreference('pushNotification', user._id, !isPushEnabled);
                       setIsPushEnabled(!isPushEnabled);
                    }}
                    inputProps={{ 'aria-label': 'Controlar bloqueio' }}
                />
            </Box>
            <Divider/>
            <Box 
                sx={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'space-between', 
                    padding: 2
                    }}
                >
                <Typography>
                    Email <i>({t('soon')})</i>
                </Typography>
                <Switch
                    disabled={true}
                    checked={isEmailEnabled}
                    onChange={async () => {
                        await togglePreference('emailNotification', user._id, !isEmailEnabled);
                        setIsEmailEnabled(!isEmailEnabled);
                    }}
                    inputProps={{ 'aria-label': 'Controlar bloqueio' }}
                />
            </Box>
            <Divider/>
        </Box>
    );
}

export default Notifications;